
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 82 75","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M60.51 12H12.14v6h48.37a3 3 0 013 3v44.29h6V21a9 9 0 00-9-9z"}}),_c('path',{attrs:{"d":"M72.47 0H24.11v6h48.36a3 3 0 013 3v44.29h6V9a9 9 0 00-9-9z"}}),_c('path',{attrs:{"d":"M50.59 25H6a6 6 0 00-6 6v38a6 6 0 006 6h44.59a6 6 0 006-6V31a6 6 0 00-6-6zM28.66 59.83a7.8 7.8 0 01-11 0l-6.56-6.54 4.24-4.24 6.54 6.54a1.8 1.8 0 002.54 0l16.82-16.82L45.48 43 28.66 59.83z","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/selectAll.svg